import { ToastContainer, toast } from 'react-toastify';

export function slugToTitleCase(str) {
    if (str !== null) {
        return str.split('-').map((word) => word[0].toUpperCase() + word.slice(1).toLowerCase()).join(' ');
    } else {
        return str;
    }
}

export function toTitleCase(str) {
    return str.replace(
        /\w\S*/g,
        function(txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }
    );
}

export function shuffleArray(array) {
    let currentIndex = array.length,  randomIndex;

    while (currentIndex !== 0) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
    }

    return array;
}

export function handleLongText(values, lengths) {
    if (values.length > lengths) {
        return values.substring(0, lengths) + ' ...';
    }
    return values;
}

export function handleError(error) {
    if (error.response.data.message != null) {
        if (Array.isArray(error.response.data.message)) {
            for (const key in error.response.data.message) {
                toast.error(`${error.response.data.message[key]}`, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } else {
            if (error.response.data.message === '') {
                toast.error(`${error.response.status + ' - ' + error.response.statusText}`, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                toast.error(`${error.response.data.message}`, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
            
        }
    } else {
        toast.error(error.response.status + ' - ' + error.response.statusText, {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }
}